export default __webpack_public_path__ + "static/FESTLTOUR_ruhpolding-adfe641fca3c72acc0792bbca00aa1ae.jpg";